import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as CertificationFeatureState from './certification.state';

export const selectCertificationState =
  createFeatureSelector<CertificationFeatureState.CertificationState>(
    CertificationFeatureState.certificationFeatureKey
  );

export const selectCertifications = createSelector(
  selectCertificationState,
  CertificationFeatureState.selectAll
);

export const selectCertificationCount = createSelector(
  selectCertificationState,
  CertificationFeatureState.selectTotal
);
